import type { DatovkaApiType } from '@gov-nx/api';
import type { ProcessControlCore } from '@gov-nx/core/hooks';
import type { Nullable, Optional } from '@gov-nx/core/types';
import type { useMyFilesStorage } from '@gov-nx/module/page';
import type { DataBoxSearchState } from '@gov-nx/store';
import type { useDataboxDateUtils } from '../utils/message';
import type {
	DataBoxConfirmModalType,
	DataBoxFolderType,
	DataBoxTimeDividedMessageList,
} from './DataBoxes.types';

export type DataBoxMessageListContextType = {
	controls: ProcessControlCore;
	dataBox: Optional<DatovkaApiType>;
	storage: ReturnType<typeof useMyFilesStorage>;
	messageList: DataBoxTimeDividedMessageList;
	messageListCount: number;
	isLoadMorePossible: boolean;
	loadMore: () => void;
	listState: DataBoxListStatesType;
	setListState: (state: DataBoxListStatesType) => void;
	messagesFilter: {
		dataBoxId: string;
		folderType: DataBoxFolderType;
		messageId?: number;
		query: Optional<string>;
		setQuery: (query: string) => void;
		hasSearch: boolean;
	};
	messagesSelect: {
		showCheckboxes: boolean;
		selectedMessageList: number[];
		setSelectedMessageList: (list: number[]) => void;
		updateSelectedMessageList: (id: number) => void;
		updateAllMessagesSelection: (check: boolean) => void;
		isAllSelected: boolean;
		isPartialySelected: boolean;
		setIsAllSelected: (isAllSelected: boolean) => void;
	};
	massOperations: {
		handleArchiveMessages: () => void;
		handleArchiveAllMessages: () => void;
		handleDeleteMessages: (permanently: boolean) => void;
		handleDeleteAllMessagesPermanently: () => void;
		handleDeleteAllMessages: () => void;
		handleRestoreMessages: () => void;
		handleEmptyTrash: () => void;
	};
	confirmModal: Nullable<DataBoxConfirmModalType>;
	setConfirmModal: (modal: Nullable<DataBoxConfirmModalType>) => void;
	loadingItems: Partial<Record<DataBoxMessageListLoadingItemsType, boolean>>;
	handleOpenMobileMenu: () => void;
	isMessageListHidden: boolean;
	previousSuggestions: DataBoxSearchState['searchHistory'];
	deleteSuggestion: (suggestion: string) => void;
	nextDataBoxForSearch?: DatovkaApiType;
	showUnreadMessagesCount: boolean;
	unreadMessagesCount: number;
	dataBoxDateUtils: ReturnType<typeof useDataboxDateUtils>;
	isQueryLoading: boolean;
	isRemoveAllLoading: boolean;
};

export enum DataBoxListStatesType {
	List = 'list',
	Search = 'search',
	MassArchive = 'massArchive',
	SearchMassArchive = 'searchMassArchive',
	MassRemove = 'massRemove',
	SearchMassRemove = 'searchMassRemove',
	MassPermanentRemove = 'massPermanentRemove',
	SearchMassPermanentRemove = 'searchMassPermanentRemove',
	MassRestore = 'massRestore',
	SearchMassRestore = 'searchMassRestore',
}

export enum DataBoxMessageListLoadingItemsType {
	Archive = 'archive',
	Remove = 'remove',
	RemovePermanently = 'removePermanently',
	Restore = 'restore',
}
